<template>
    <section class="text-left">
        <div v-if="error" class="alert alert-danger" role="alert">
            <button @click="error=false;errorMessage=''" type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            {{errorMessage}}
        </div>
        <i v-if="loading" class="fa fa-spin fa-spinner"></i>
        <div ref="container">

        </div>
<!--        <div class="form-group">-->
<!--            <label>Country:</label>-->
<!--            <select class="form-control" v-model="country">-->
<!--                <option v-for="(v,k) in countries" :key="k" :value="k">{{v}}</option>-->
<!--            </select>-->
<!--        </div>-->
        <div class="form-inline">
            <b-form-group id="input-group-3" label="Country: " label-for="input-3" class="mt-2">
                <b-form-select
                        id="input-3"
                        v-model="country"
                        :options="countries"
                        required
                        class="ml-1"
                ></b-form-select>
            </b-form-group>
        </div>
        <div v-if="vats[country]" class="form-group mt-3">
            <div class="radio">
                <label>
                    <input type="radio" v-model="customer" value="Person"> Person (price incl. VAT)
                </label>
            </div>
            <div class="radio">
                <label>
                    <input type="radio" v-model="customer" value="Company"> Company (price excl. VAT)
                </label>
            </div>
            <span></span>
        </div>
        <div v-if="vats[country] && customer === 'Company'" class="form-group js-tax-id-fe">
            <div class="form-inline">
                <label class="mr-2">VAT ID:</label>
                <b-input-group :prepend="vats[country].vatId">
                    <b-form-input v-model="taxNumber"></b-form-input>
                </b-input-group>
            </div>
            <span id="frm-payment-taxid_message" class=""></span>
        </div>
        <table class="table mt-3 mb-0 table-sm">
            <tr>
                <td><strong>Price</strong></td>
                <td>${{price| round(2)}}</td>
            </tr>
            <tr>
                <td><strong>VAT</strong></td>
                <td>+{{vat}}%</td>
            </tr>
            <tr>
                <td><h2><strong>Total: </strong></h2></td>
                <td><h2><strong><span class="text-success js-total">${{total | round(2)}}</span></strong></h2></td>
            </tr>
        </table>
        <button class="btn btn-primary" :class="{disabled: loading || paid}" ref="submit">
            <i v-if="paying" class="fa fa-spinner fa-spin"></i> Confirm payment
        </button>
    </section>
</template>

<script>
    import {api} from '../_services/ritetag'
    import _ from 'lodash'
    import dropin from 'braintree-web-drop-in'

    export default {
        name: 'Payment',
        props: {
            type: {
                default: '',
                type: String
            },
            price: {
                default: 0,
                type: Number
            },
            callback: {
                default: () => {},
                type: Function
            },
            query: {
                default: () => {},
                type: Object
            }
        },
        data () {
            return {
                loading: false,
                country: null,
                customer: 'Person',
                vat: 0,
                taxNumber: '',
                // price: 0,
                countries: [],
                vats: [],
                paying: false,
                paid: false,
                error: false,
                errorMessage: ''
            }
        },
        watch: {
            country () {
                this.updateVat()
            },
            customer () {
                this.updateVat()
            }
        },
        computed: {
            total () {
                return this.price * (100 + this.vat) / 100
            }
        },
        methods: {
            updateVat () {
                if (this.vats[this.country] && this.customer === 'Person') {
                    this.vat = this.vats[this.country].vat
                } else {
                    this.vat = 0
                }
            },
            initialize (authorization) {
                const button = this.$refs.submit
                const container = this.$refs.container
                const self = this
                dropin.create({
                    authorization: authorization,
                    container: container,
                    locale: 'en_US',
                    paypal: {
                        flow: 'vault'
                    }
                }, (createErr, instance) => {
                    this.loading = false
                    button.addEventListener('click', () => {
                        if (self.paying || self.paid) {
                            return
                        }
                        self.error = false
                        self.paying = true
                        instance.requestPaymentMethod((error, payload) => {
                            if (error) {
                                // todo console.log(error.message)
                                self.error = true
                                if (error.message === 'No payment method is available.') {
                                    self.errorMessage = 'Please choose whether you want to pay by Paypal or Card'
                                } else {
                                    self.errorMessage = error.message
                                }
                                self.paying = false
                                return
                            }
                            // Submit payload.nonce to your server
                            self.pay(payload.nonce)
                                .then(resp => {
                                    self.paying = false
                                    self.paid = true
                                    if (this.callback) {
                                        this.callback(resp.data)
                                    }
                                })
                                .catch(err => {
                                    self.paying = false
                                    self.error = true
                                    self.errorMessage = err.response.data.message
                                    // self.$notify({type: 'error', text: err.response.data.message})
                                })
                        })
                    })
                })
            },
            clientToken () {
                this.loading = true
                return api.getPaymentToken()
            },
            pay (nonce) {
                const query = _.defaults({
                    nonce: nonce,
                    country: this.country,
                    customer: this.customer,
                    taxNumber: this.taxNumber
                }, this.query)
                return api.payInstagramReport(query)
            },
            show () {
                this.clientToken()
                    .then(resp => {
                        this.initialize(resp.data.authorization)
                    })
                // this.getData().then(resp => {
                //     this.countries = resp.data.data.countries
                //     this.vats = resp.data.data.vats
                //     this.customer = resp.data.data.user.customer
                //     this.vatNumber = resp.data.data.user.vatNumber
                //     this.country = resp.data.data.user.country
                // })
            }
        },
        mounted () {
            api.getCountries()
                .then(resp => {
                    this.countries = resp.data.data.countries
                    this.vats = resp.data.data.vats
                    this.customer = resp.data.data.user.customer
                    this.vatNumber = resp.data.data.user.vatNumber
                    this.country = resp.data.data.user.country
                })
            this.clientToken()
                .then(resp => {
                    this.initialize(resp.data.authorization)
                })
        }
    }
</script>

<style scoped>

</style>
